import React from 'react';
import gql from 'graphql-tag';
import { graphql } from 'react-apollo/index';
import moment from 'moment';
import {
  ButtonDropdown,
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
  Col,
  Row,
} from 'reactstrap';

import AppComponent from '../components/core/AppComponent';
import CoreMetric from '../components/core/CoreMetric';

const durationKeys = [
  ['days', 'd'],
  ['hours', 'h'],
  ['minutes', 'm'],
  ['seconds', 's'],
];

const dropdownOptionsDefault = '24hours';
const dropdownOptions = {
  '24hours': {
    label: 'Last 24 hours',
    qty: 1,
    unit: 'days',
  },
  '7days': {
    label: 'Last 7 days',
    qty: 7,
    unit: 'days',
  },
  '30days': {
    label: 'Last 30 days',
    qty: 30,
    unit: 'days',
  },
};

class CoreMetrics extends AppComponent {
  constructor(props) {
    super(props);

    this.state = {
      dropdownOpen: false,
      dropdownOption: dropdownOptionsDefault,
      moment: moment(),
    };
  }

  static averageTime = (alerts, startTimeKey, endTimeKey) => {
    const filteredAlerts = alerts.filter(alert => alert[startTimeKey] && alert[endTimeKey]);

    if (filteredAlerts.length === 0) {
      return 'N/A';
    }

    let totalSeconds = 0;
    filteredAlerts.forEach(alert => {
      totalSeconds += moment(alert[endTimeKey]).diff(alert[startTimeKey], 'seconds');
    });

    const avgSeconds = Math.round(totalSeconds / filteredAlerts.length);
    const duration = moment.duration(avgSeconds, 'seconds');
    const resultArray = [];

    durationKeys.forEach(dk => {
      const dur = duration.get(dk[0]);
      if (resultArray.length || dur) {
        resultArray.push(`${dur}${dk[1]}`);
      }
    });

    return resultArray.join(' ');
  };

  toggleDropdownOpen = () => {
    this.setState({
      dropdownOpen: !this.state.dropdownOpen,
    });
  };

  selectOption = option => {
    this.setState({
      dropdownOption: option,
      moment: moment(),
    });

    const optionData = dropdownOptions[option];

    this.props.alertsQuery.refetch({
      id: this.props.facilityId,
      where: {
        createdAt_gte: `${this.state.moment.subtract(optionData.qty, optionData.unit).format()}`,
      },
    });
  };

  render() {
    const { alertsQuery } = this.props;

    // if (alertsQuery.loading) {
    //   return (
    //     <Loading />
    //   );
    // }

    const { facilityAlerts: alerts } = alertsQuery;

    const coreMetrics = [
      {
        header: 'Total Metrics',
        body: alertsQuery.loading ? '0' : `${alerts.length}`,
      },
      {
        header: 'Avg. Response Time',
        body: alertsQuery.loading ? '0' : CoreMetrics.averageTime(alerts, 'createdAt', 'confirmedAt'),
      },
      {
        header: 'Avg. Care Time',
        body: alertsQuery.loading ? '0' : CoreMetrics.averageTime(alerts, 'createdAt', 'resolvedAt'),
      },
    ];

    return (
      <React.Fragment>
        <div className="text-right">
          <ButtonDropdown isOpen={this.state.dropdownOpen} toggle={this.toggleDropdownOpen}>
            <DropdownToggle caret color="link">
              {dropdownOptions[this.state.dropdownOption].label}
            </DropdownToggle>
            <DropdownMenu>
              {
                Object.keys(dropdownOptions).map(ddOption => (
                  <DropdownItem
                    key={ddOption}
                    disabled={this.state.dropdownOption === ddOption}
                    onClick={() => this.selectOption(ddOption)}
                  >
                    {dropdownOptions[ddOption].label}
                  </DropdownItem>
                ))
              }
            </DropdownMenu>
          </ButtonDropdown>
        </div>
        <Row>
          {
            coreMetrics.map(cm => (
              <Col key={cm.header}>
                <CoreMetric
                  header={cm.header}
                  body={cm.body}
                  loading={alertsQuery.loading}
                />
              </Col>
            ))
          }
        </Row>
      </React.Fragment>
    );
  }
}

const ALERTS_QUERY = gql`
    query($id: String!, $where: AlertWhereInput) {
        facilityAlerts(
          facilityId: $id
          where: $where
        ){
            createdAt
            claimedAt
            confirmedAt
            resolvedAt
        }
    }
`;

export default graphql(ALERTS_QUERY, {
  name: 'alertsQuery',
  options: props => ({
    variables: {
      id: props.facilityId,
      where: {
        createdAt_gte: `${moment().subtract(1, 'days').format()}`,
      },
    },
    // pollInterval: 5000,
  }),
})(CoreMetrics);



// WEBPACK FOOTER //
// ./src/containers/CoreMetrics.js